<template>
  <section
    v-if="hasData"
    class="local-lm-orders-title-mtop"
  >
    <div class="lm-header">
      <h3
        v-if="orders && orders.length === 0 && hasSummited"
        class="subtitle is-5"
        v-t="$t('Orders.noResults')"
      />
      <h3
        v-if="orders && orders.length > 0"
        class="subtitle is-5"
        v-t="$t('Orders.results')"
      />
    </div>
    <div
      v-if="orders && orders.length"
    >
      <div
       class="container local-lm-order-btns"
      >
        <order-table-filter />
        <b-button
          :icon-right="iconOrd"
          class="lm-default-btn--no-outline local-lm-xs-marginTop"
          @click.prevent="ord"
          :disabled="hasOpenFilterOrd"
        />
        <b-button
          icon-right="file-delimited-outline"
          class="lm-default-btn--no-outline local-lm-xs-marginTop"
          @click.prevent="downloadCsvFile"
        >
          {{ $t('Orders.exportCsvFile') }}
        </b-button>
      </div>
      <b-table
        ref="table"
        :data="orders"
        :paginated="isPaginated"
        :pagination-simple="isPaginationSimple"
        :pagination-position="paginationPosition"
        :checkbox-position="checkboxPosition"
        :checked-rows.sync="checkedRows"
        :total="totalCount"
        :current-page.sync="currentPage"
        :row-class="(row) => rowLogicSelector(row)"
        :is-row-checkable="(row) => rowCheckabled(row)"
        backend-pagination
        per-page="13"
        detail-key="id"
        checkable
        detailed
        hoverable
        narrowed
        class="local-lm-orders-table"
      >
        <b-table-column
          field="id"
          width="160"
          :label="$t('Orders.labelOrder')"
          v-slot="props"
        >
          <div>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.orderId'"
              />
              {{ props.row.supplierOrderCode }}
            </p>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.store'"
              >
              </span>
              {{ props.row.store.name }}
            </p>
          </div>
        </b-table-column>
        <b-table-column
          field="id"
          width="200"
          v-slot="props"
        >
          <div>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.supplierID'"
              />
              {{ props.row.supplierID }}
            </p>
          </div>
        </b-table-column>
        <b-table-column
          field="id"
          width="200"
          v-slot="props"
        >
          <div>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.availability'"
              />
              {{ props.row.availableDate | stripHour }}
            </p>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.pyxisCreation'"
              />
              {{ props.row.orderDate | stripHour }}
            </p>
          </div>
        </b-table-column>
        <b-table-column
          field="id"
          :label="$t('Orders.labelPackage')"
          width="300"
          v-slot="props"
        >
          <div>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.partner'"
              />
              {{ props.row.partner }}
              <transport-communications
                v-if="props.row.partner !== 'N.A.'"
                class="local-lm__partner-status"
                :state="props.row.communicationStatus"
              />
            </p>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.numberVolumes'"
              />
              <volumes-tag
                :volumes="props.row.volumeTotal || null"
                :pallets="props.row.palletTotal || null"
                :equivalents="props.row.palletEquivalentNumber || null"
                :normalPalletEquivalent="props.row.palletEquivalentForPartner || null"
              />
            </p>
          </div>
        </b-table-column>
        <b-table-column
          field="id"
          width="180"
          v-slot="props"
        >
          <div>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.labelWeight'"
              />
              <span
                v-html="$t('Orders.volumeWeight', { weight: props.row.weight, volume: props.row.volume })"
              />
            </p>
          </div>
        </b-table-column>
        <b-table-column
          field="id"
          width="130"
          v-slot="props"
        >
          <div>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.labelState'"
              />
              {{
                props.row.supplyOrderState
                  ? $t(`Orders.${props.row.supplyOrderState}`)
                  : $t('Errors.warningNone')
              }}
            </p>
          </div>
        </b-table-column>
        <b-table-column
          width="20"
          field="props.row.customerOrderCode"
          v-slot="props"
        >
          <span>
            <btn-reject-order
              v-bind="props.row"
              :actions="allActions"
            />
          </span>
        </b-table-column>
        <b-table-column
          width="20"
          v-slot="props"
        >
          <span v-if="props.row.supplyOrderState === 'AWAITS_CONFIRMATION'">
            <b-tooltip
              :label="$t('Orders.tooltipOp10')"
              type="is-dark"
            >
              <b-button
                icon-right="check-circle"
                class="local-lm-btn-row"
                @click.prevent="setInPreparationAndReloadOrders(props.row)"
              />
            </b-tooltip>
          </span>
        </b-table-column>
        <b-table-column
          width="20"
          v-slot="props"
        >
          <span>
            <b-tooltip
              :label="$t('Orders.tooltipOp4')"
              type="is-dark"
            >
              <b-button
                v-show="!visibleLogicSelector(props.row.supplyOrderState)"
                icon-right="eye-outline"
                class="local-lm-btn-row"
                @click.prevent="openModalItems([ ...props.row ])"
              />
            </b-tooltip>
          </span>
        </b-table-column>
        <b-table-column
          width="20"
          field="props.row.customerOrderCode"
          v-slot="props"
        >
          <span>
            <b-tooltip
              :label="$t('Orders.tooltipOp5')"
              type="is-dark"
            >
              <b-button
                v-show="!hideButtons(props.row.supplyOrderState)"
                icon-right="pencil-outline"
                class="local-lm-btn-row"
                @click.prevent="openModal([ ...props.row ], allActions.editOrder)"
              />
            </b-tooltip>
          </span>
        </b-table-column>
        <b-table-column
          width="20"
          field="props.row.customerOrderCode"
        >
          <template v-slot:header="">
            <b-tooltip
              :label="$t('Orders.tooltipOp1')"
              type="is-dark"
            >
              <b-button
                icon-right="printer"
                class="local-lm-btn-header"
                @click.prevent="downloadLabel(checkedRows)"
              />
            </b-tooltip>
          </template>
          <template v-slot="props">
            <span>
              <b-tooltip
                 v-show="!hideButtons(props.row.supplyOrderState)"
                :label="checkPrintState(props.row)"
                position="is-left"
                type="is-dark"
              >
                <b-button
                  :icon-right="checkPrint(props.row)"
                  :disabled="checkDisabledPrint(props.row)"
                  :class="[ 'local-lm-btn-row', { 'local-lm-block-action': checkDisabledPrint(props.row) }]"
                  @click.prevent="downloadLabel([ ...props.row ])"
                />
              </b-tooltip>
            </span>
          </template>
        </b-table-column>
        <b-table-column
          width="20"
          field="props.row.customerOrderCode"
        >
          <template v-slot:header="">
            <b-tooltip
              :label="$t('Orders.tooltipOp2')"
              position="is-left"
              type="is-dark"
            >
              <b-button
                icon-right="truck-delivery"
                class="local-lm-btn-header"
                @click.prevent="callActions(checkedRows, allActions.available)"
              />
            </b-tooltip>
          </template>
          <template v-slot="props">
            <span>
              <b-tooltip
                v-show="!hideButtons(props.row.supplyOrderState)"
                v-if="showBtnCommunications(props.row)"
                :label="checkDeliveryState(props.row)"
                position="is-left"
                type="is-dark"
              >
                <b-button
                  :icon-right="checkDelivery(props.row)"
                  :disabled="checkDisabledDelivery(props.row)"
                  :class="[ 'local-lm-btn-row', { 'local-lm-block-action': checkDisabledDelivery(props.row) }]"
                  @click.prevent="callActions([ ...props.row ], allActions.available)"
                />
              </b-tooltip>
              <b-tooltip
                v-if="visibleLogicSelector(props.row.supplyOrderState)"
                :label="$t('Orders.tooltipOp8')"
                position="is-left"
                type="is-dark"
              >
                <b-button
                  icon-right="check-all"
                  class="local-lm-btn-row__state"
                  @click.prevent="callActions([ ...props.row ], allActions.cancelConfirmed)"
                />
              </b-tooltip>
            </span>
          </template>
        </b-table-column>
      </b-table>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { mixin } from '@/mixins'
import OrderTableFilter from '@/components/filters/OrderTableFilter'
import BtnRejectOrder from '@/components/miscellaneous/BtnRejectOrder'
import VolumesTag from '@/components/VolumesTag'
import TransportCommunications from '@/components/miscellaneous/TransportCommunications'
import { services } from '@/services'

export default {
  name: 'Orders',
  mixins: [
    mixin.notifications,
    mixin.dates
  ],
  computed: {
    ...mapGetters('orders', [
      'orders',
      'actions'
    ]),
    ...mapGetters('filters', ['filtersSelected']),
    allActions () {
      return this.actions
    },
    totalCount () {
      return this.$store.getters['orders/totalCount']
    },
    currentPage: {
      get () {
        return this.$store.getters['filters/currentPage']
      },
      set (newPage) {
        this.$store.dispatch('filters/setPage', newPage)
        this.$eventBus.$emit('onPageChange', newPage)
      }
    }
  },
  data () {
    return {
      hasSummited: false,
      hasData: false,
      checkboxPosition: 'left',
      isPaginated: true,
      isPaginationSimple: true,
      paginationPosition: 'top',
      checkedRows: [],
      iconOrd: 'sort-descending',
      defaultOrd: 'desc',
      hasOpenFilterOrd: this.$route.name === 'Orders' || false
    }
  },
  components: {
    VolumesTag,
    BtnRejectOrder,
    OrderTableFilter,
    TransportCommunications
  },
  async mounted () {
    this.$eventBus.$on('emptyOrders', () => {
      this.hasSummited = true
      this.hasData = true
    })

    this.$eventBus.$on('orders', () => {
      this.hasData = true
      this.checkedRows = []
    })

    this.$eventBus.$on('cleanFilters', () => {
      this.hasData = false
    })

    this.$eventBus.$on('selectOrderFilter', flag => {
      this.hasOpenFilterOrd = flag
    })
  },
  methods: {
    ...mapActions('orders', ['downloadCsv']),
    rowLogicSelector ({ supplyOrderState, deadlineForReject }) {
      const canReject = this.diffDate(deadlineForReject)

      return {
        'local-lm-row-attention__cancel-state': supplyOrderState === 'CANCELED',
        'local-lm-row-attention__canReject-state': canReject === true
      }
    },
    rowCheckabled ({ partner }) {
      return !['CTT'].includes(partner.toUpperCase())
    },
    dirtyOrderState ({ volumeTotal, palletTotal, palletEquivalentNumber }) {
      return (volumeTotal === 0 && palletTotal === 0 && palletEquivalentNumber === 0) || false
    },
    checkPrint (row) {
      if (row.partner === 'CTT') return ''
      return this.dirtyOrderState(row) ? 'printer-off' : 'printer'
    },
    checkDisabledPrint (row) {
      if (row.partner === 'CTT') return true
      return this.dirtyOrderState(row)
    },
    checkPrintState (row) {
      return this.dirtyOrderState(row) ? this.$t('Orders.tooltipOp6') : this.$t('Orders.tooltipOp1')
    },
    checkDelivery (row) {
      return this.dirtyOrderState(row) ? 'truck' : 'truck-delivery'
    },
    checkDeliveryState (row) {
      return this.dirtyOrderState(row) ? this.$t('Orders.tooltipOp7') : this.$t('Orders.tooltipOp2')
    },
    checkDisabledDelivery (row) {
      return this.dirtyOrderState(row)
    },
    showBtnCommunications ({ communicationStatus, supplyOrderState }) {
      if (communicationStatus === 'IN_PROGRESS') return false

      return !this.visibleLogicSelector(supplyOrderState)
    },
    hideButtons (supplyOrderState) {
      return this.visibleLogicSelector(supplyOrderState) || supplyOrderState === 'AWAITS_CONFIRMATION'
    },

    ord () {
      this.$store.dispatch('filters/setOrd', this.defaultOrd)

      if (this.defaultOrd === 'asc') {
        this.defaultOrd = 'desc'
        this.iconOrd = 'sort-descending'
      } else {
        this.defaultOrd = 'asc'
        this.iconOrd = 'sort-ascending'
      }

      this.$eventBus.$emit('getOrders')
    },
    visibleLogicSelector (status) {
      return (status === 'CANCELED') || false
    },
    openModal (orders, type) {
      const data = {
        orders,
        type
      }

      this.$store.dispatch('modal/launchModalWithData', data)
    },
    openModalItems (order) {
      this.$store.dispatch('items/launchModalWithItems', order[0])
    },
    async callActions (orders, type) {
      if (!orders.length) return this.wrong(this.$t('Errors.shouldChoose'))

      if (type === 'AWAITS_DISPATCH') {
        const checkPartner = orders.filter(order => order.partner === 'N.A.')

        if (checkPartner.length) return this.wrong(this.$t('Errors.warningEdit', { orders: checkPartner.map(check => check.supplierOrderCode) }))
      }

      const data = {
        orders,
        type
      }

      const changes = await this.$store.dispatch('orders/setActions', data)
      if (!changes.level) return this.wrong(this.$t(changes.errorText))

      this.$eventBus.$emit('getOrders')
      this.sucess(this.$t('Common.success'))
    },
    async setInPreparation (data) {
      await this.$store.dispatch('orders/setStateInPreparation', data)
    },
    reloadOrders () {
      this.$eventBus.$emit('getOrders')
    },
    async setInPreparationAndReloadOrders (data) {
      await this.setInPreparation(data)
      this.reloadOrders()
    },
    async downloadLabel (orders) {
      if (!orders.length) return this.wrong(this.$t('Errors.shouldChoose'))

      const labels = await services.labelService(orders)
      if (labels.okGenericLabel && labels.okGenericLabel.error) return this.wrong(this.$t('Errors.warningEdit', { orders: labels.okGenericLabel.customerOrderCode }))
      if (labels.okDHLLabel && labels.okDHLLabel.error) return this.wrong(this.$t('Errors.warningEdit', { orders: labels.okDHLLabel.customerOrderCode }))
      if (!labels.okGenericLabel || !labels.okDHLLabel) this.wrong(this.$t('Errors.somethingWrong'))
    },
    async downloadCsvFile () {
      const filters = this.filtersSelected

      const file = await this.downloadCsv({ filters })
      if (!file) this.wrong(this.$t('Errors.downloadFile'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/Orders.vue